import {setCookie, getCookie} from '../functions.js';

const notice = document.getElementById("cookieNotice");

if(notice) {

  if (!getCookie('cookie-banner')) {
    console.log('no consent');
    notice.classList.remove('hidden');
    notice.classList.add('block');
  }
  else {
    console.log('consent');
  }

  notice.querySelector('button').addEventListener('click', function (e) {
    notice.classList.add('hidden');
    notice.classList.remove('block');
    setCookie('cookie-banner', 'consent', '14' )
  });
}
